/* Chrome CSS must be the LAST stylesheet in the document so its overrides win.
   On the mockup every page's <style> sits in <head>, so appending to <head> was enough.
   On Shopify the page's CSS lives inside the section, which is in <body> and therefore
   later in document order, so head-injected rules lost: .pc-img kept its 22px SVG-era
   padding and photos rendered 253px inside a 297px tile. Appending to <body> puts these
   rules last on both, so the store and the mockup render identically. */
function osoAddStyle(el){ (document.body || document.documentElement).appendChild(el); return el; }

/* ============ OSO shared chrome, one header + footer for every page ============ */
(function(){
  const p=location.pathname;
  /* Shopify's hCaptcha interstitial (/challenge) is its own bare page, served when
     it wants to verify a form submission. Injecting our chrome into it put the fixed
     header straight across "let us know you're not a robot" and hung the footer's
     newsletter block under Shopify's Submit button — it read as a broken page at the
     exact moment a shopper is deciding whether to trust the site. Leave it alone:
     no header, no footer, just a light background so it still feels like OSO. */
  if(/^\/challenge/.test(p)){
    const s=document.createElement('style');
    s.textContent='html,body{background:#eae8df;color:#151310}'+
      'body{font-family:system-ui,Arial,sans-serif;padding:34px 20px;line-height:1.6}';
    (document.head||document.documentElement).appendChild(s);
    return;
  }
  const onHome = p==='/' || p==='' || /oso-hero\.html$/.test(p);
  const onAbout = /about\.html$/.test(p);
  const onContact = /contact\.html$/.test(p);
  const onShop = /shop\.html$/.test(p) || /product\.html$/.test(p);
  const onCart = /cart\.html$/.test(p);
  const onWish = /wishlist\.html$/.test(p);
  const onAccount = /account\.html$/.test(p) || /checkout\.html$/.test(p);
  const H = hash => onHome ? hash : ('/'+hash);
  /* The Material / The Fit / Life in the Slow Lane all live on Our Story */
  const A = hash => onAbout ? hash : ('/pages/our-story'+hash);
  const homeHref = onHome ? '#hero' : '/';
  const storyHref = onAbout ? '#abHero' : '/pages/our-story';
  const contactHref = onContact ? '#ctHero' : '/pages/contact';

  /* ---- styles ---- */
  const css = `
/* OSO is a light brand and has no dark theme. Chrome and Samsung Internet will
   auto-invert a page that never states a scheme ("force dark"), which is what made
   the site show up dark on some phones. "only light" opts out of that inversion. */
:root{color-scheme:only light}
html,body{background-color:#eae8df}
/* iOS Safari paints button and form text in its system blue when no colour is set,
   which is why product titles inside the build-a-set cards turned blue. Any element
   with its own colour rule still wins, because a class beats a bare element selector. */
button,input,select,textarea{color:inherit}
/* ---- product photography: every tee tile on the site is a photo now ---- */
.tee-img{display:block;width:100%;height:100%;object-fit:cover;object-position:50% 40%;background:#e4e1d6;
  transition:transform .55s cubic-bezier(.2,.7,.2,1);will-change:transform;filter:none!important}
/* the shop and homepage grids show the WHOLE photograph. The shots are 2:3 on a
   white sweep and the frames are 4:5, so object-fit cover was cutting the head and
   the legs off. contain, on the same white, keeps the model complete and the seam
   invisible. (No backticks in here — this stylesheet is a JS template literal.) */
.sh-img .tee-img,.pc-img .tee-img,.cc .cim .tee-img{object-fit:contain;object-position:50% 50%;background:#fff}
/* ---- sold out ----
   One treatment for every size button on the site: PDP, quick view, the homepage
   feature, the wishlist and build-a-set. Struck through and faded, still legible,
   never clickable — so a shopper can see the size exists but has gone. */
.pd-z.oos,.qv-z.oos,.fsz.oos,.wl-z.oos,.bs-sz button.oos{
  position:relative;color:#a8a49a;border-style:dashed;background:transparent;
  cursor:not-allowed;opacity:.72}
.pd-z.oos::after,.qv-z.oos::after,.fsz.oos::after,.wl-z.oos::after,.bs-sz button.oos::after{
  content:"";position:absolute;left:14%;right:14%;top:50%;height:1px;background:currentColor;opacity:.75}
.pd-z.oos:hover,.qv-z.oos:hover,.fsz.oos:hover,.wl-z.oos:hover{border-color:inherit;background:transparent}
/* a colourway with nothing left in any size */
.pd-s.oos,.qv-s.oos{cursor:not-allowed;opacity:.4}
.pd-s.oos::after{content:"";position:absolute;left:-3px;right:-3px;top:50%;height:1.5px;
  background:#7b766c;transform:rotate(-45deg)}
.pd-s,.qv-s{position:relative}
/* the buy button when the whole colourway is gone */
.pdp-add.sold,.pdp-add:disabled{background:#b4afa4;cursor:not-allowed}
.pdp-sticky button:disabled{background:#b4afa4;cursor:not-allowed}
.tee-missing{width:100%;height:100%;background:repeating-linear-gradient(135deg,#e4e1d6,#e4e1d6 12px,#e0ddd1 12px,#e0ddd1 24px);
  display:flex;align-items:center;justify-content:center;text-align:center;padding:12px}
.tee-missing span{font-size:12px;font-weight:700;letter-spacing:.4px;color:#57534b;line-height:1.5}
.tee-missing b{display:block;margin-top:5px;font-size:9.5px;letter-spacing:1.6px;text-transform:uppercase;color:#8c8880;font-weight:700}
/* the frames were built around a floating SVG, photos fill them edge to edge */
.sh-img,.pc-img,.pdp-main,.wl-im,.qv-tee,.dr-im,.pcard .th,.cc .cim,.pdp-rcard .im,.rec-card .im,
.co-line .im,.ord-items .im,.bs-slot .im,.ft-stage{padding:0;overflow:hidden}
.sh-card:hover .tee-img,.pc:hover .tee-img,.pdp-rcard:hover .tee-img,.rec-card:hover .tee-img,
.wl-card:hover .tee-img,.cc:hover .tee-img,.pcard:hover .tee-img{transform:scale(1.045)}
/* the paper grain is a fixed multiply layer at z-index 160, photographs sit above it
   so the product stays true to colour instead of being dulled by the texture */
.sh-card,.pc,.cc,.pdp-rcard,.rec-card,.wl-card,.life-cell,.ab-ph,.ab-fitcard,
.bs-opt,.bs-slot,.feat-tees,.qv-stage,.dr-im,.co-line .im,.ord-items .im,.ci-img{position:relative;z-index:170}
/* the gallery is sticky already, only lift it, never restate its position */
.pdp-gallery{z-index:170}
.oso-nav{position:fixed;top:0;left:0;right:0;z-index:300;display:flex;align-items:center;justify-content:space-between;
  padding:8px clamp(18px,3.5vw,48px);background:rgba(234,232,223,.9);-webkit-backdrop-filter:blur(12px);backdrop-filter:blur(12px);
  border-bottom:1px solid rgba(0,0,0,.09)}
body.has-annc .oso-nav{top:40px}
/* Shopify's built-in policy pages (/policies/*) render in a bare container with no
   top offset, so the fixed nav sat on top of the title. Same layout and type as the
   themed page template, so a policy page does not look like a different website. */
.shopify-policy__container{max-width:820px!important;margin:0 auto!important;padding:132px 24px 96px!important}
.shopify-policy__title{text-align:left!important;margin:0!important;padding:0!important}
.shopify-policy__title h1{font-size:clamp(30px,5vw,48px);line-height:1.08;letter-spacing:-.02em;
  margin:0 0 26px;padding-bottom:26px;border-bottom:1px solid rgba(20,16,36,.12);color:var(--ink,#151310)}
.shopify-policy__body{max-width:none!important;font-size:15.5px;line-height:1.78;color:#3a3733}
.shopify-policy__body>.rte>*+*{margin-top:16px}
.shopify-policy__body h2{font-size:21px;line-height:1.25;margin-top:38px;color:var(--ink,#151310)}
.shopify-policy__body h3{font-size:17px;line-height:1.3;margin-top:28px;color:var(--ink,#151310)}
.shopify-policy__body ul,.shopify-policy__body ol{padding-left:22px}
.shopify-policy__body li+li{margin-top:7px}
.shopify-policy__body a{color:#563e38;text-underline-offset:3px}
@media(max-width:700px){.shopify-policy__container{padding:104px 20px 72px!important}}
/* homepage: transparent over the hero, solid once you scroll past it */
.oso-nav.tr{background:transparent;-webkit-backdrop-filter:none;backdrop-filter:none;border-bottom-color:transparent}
.oso-nav.tr.on-dark .oso-nav-link,.oso-nav.tr.on-dark .oso-ic{color:#eae8df}
.oso-nav.tr.on-dark .oso-nav-lg svg path{fill:#eae8df}
.oso-nav.tr.on-dark .oso-badge{background:#eae8df;color:#141310}
.oso-nav-lg{display:flex;align-items:center;flex:0 0 auto;position:relative;z-index:2}
.oso-nav-lg .lg-lockup{width:78px;display:block}
.oso-nav-lg svg{width:100%;height:auto;display:block}.oso-nav-lg svg path{fill:#000}
.oso-nav-links{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);display:flex;gap:8px;align-items:center}
.oso-nav-link{font-size:12px;color:#000;text-decoration:none;padding:8px 16px;letter-spacing:1.3px;text-transform:uppercase;font-weight:600;transition:opacity .2s;white-space:nowrap;opacity:.58}
.oso-nav-link:hover{opacity:1}.oso-nav-link.active{opacity:1}
.oso-icons{display:flex;align-items:center;gap:2px;flex:0 0 auto;position:relative;z-index:2}
.oso-ic{position:relative;width:40px;height:40px;display:flex;align-items:center;justify-content:center;color:#000;text-decoration:none;transition:opacity .2s;opacity:.66}
.oso-ic:hover{opacity:1}
.oso-ic.active{opacity:1}
.oso-ic svg{width:20px;height:20px;fill:none;stroke:currentColor;stroke-width:1.6}
.oso-badge{position:absolute;top:2px;right:2px;min-width:17px;height:17px;padding:0 4px;border-radius:9px;background:#000;color:#eae8df;font-size:10.5px;font-weight:800;display:none;align-items:center;justify-content:center}
/* ---- phone menu ---- */
.oso-burger{display:none;width:40px;height:40px;border:none;background:none;cursor:pointer;
  flex-direction:column;align-items:center;justify-content:center;gap:5px;padding:0;margin-left:2px}
/* three black bars; the middle one fades and the outer two cross into an X when open */
.oso-burger span{display:block;width:19px;height:1.6px;background:#141310;border-radius:2px;transition:transform .3s,opacity .2s}
.oso-burger.on span:nth-child(1){transform:translateY(6.6px) rotate(45deg)}
.oso-burger.on span:nth-child(2){opacity:0}
.oso-burger.on span:nth-child(3){transform:translateY(-6.6px) rotate(-45deg)}
/* over the dark hero the bars invert so they stay readable */
.oso-nav.tr.on-dark .oso-burger span{background:#eae8df}
.oso-mnav{position:fixed;inset:0;z-index:299;background:#eae8df;display:flex;flex-direction:column;justify-content:center;
  gap:2px;padding:96px 30px 40px;opacity:0;visibility:hidden;transform:translateY(-14px);
  transition:opacity .3s ease,transform .35s cubic-bezier(.2,.7,.2,1),visibility .3s}
.oso-mnav.on{opacity:1;visibility:visible;transform:none}
.oso-mlink{font-size:clamp(30px,9vw,42px);letter-spacing:-.03em;font-weight:700;color:#141310;text-decoration:none;padding:11px 0;line-height:1.1}
.oso-mlink.active{opacity:.42}
.oso-mfoot{margin-top:34px;padding-top:24px;border-top:1px solid rgba(0,0,0,.12);display:grid;grid-template-columns:1fr 1fr;gap:14px 18px}
.oso-mfoot a{font-size:13px;letter-spacing:1.4px;text-transform:uppercase;font-weight:700;color:#57534b;text-decoration:none}
body.oso-mopen{overflow:hidden}
@media(max-width:820px){.oso-nav-links{display:none}.oso-nav-lg .lg-lockup{width:60px}.oso-burger{display:flex}}
@media(min-width:821px){.oso-mnav{display:none}}
/* paper grain, one source, site-wide */
.oso-grain{position:fixed;inset:0;z-index:160;pointer-events:none;opacity:.26;mix-blend-mode:multiply;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='g'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.62' numOctaves='4' stitchTiles='stitch'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0.23  0 0 0 0 0.22  0 0 0 0 0.2  0 0 0 0.92 0'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23g)'/%3E%3C/svg%3E")}
/* the hero is a sticky stage (its own stacking context), it clears the global
   grain and carries its own, layered beneath the product grid */
.hero .stage{z-index:170}
.oso-grain-in{position:absolute;z-index:1}
#gridWrap{z-index:2}
/* ===== footer ===== */
.oso-foot{position:relative;z-index:5;background:#17150f;color:#a8a49a;padding:34px 24px 26px;overflow:hidden}
.oso-foot-mark{position:absolute;left:50%;bottom:-4.2vw;transform:translateX(-50%);font-weight:800;letter-spacing:.02em;font-size:26vw;line-height:.7;color:rgba(234,232,223,.028);pointer-events:none;z-index:0;white-space:nowrap}
.oso-foot>*:not(.oso-foot-mark){position:relative;z-index:1}
.oso-foot-news{max-width:1120px;margin:0 auto;transform:translateY(-26px);background:#211f18;border:1px solid rgba(234,232,223,.12);border-radius:4px;padding:22px 30px;display:flex;align-items:center;justify-content:space-between;gap:30px;flex-wrap:wrap;box-shadow:0 24px 60px rgba(0,0,0,.35)}
.oso-foot-news .fn-k{color:#8c8880;font-size:11px;letter-spacing:2.4px;text-transform:uppercase;font-weight:800}
.oso-foot-news h4{color:#eae8df;font-size:clamp(18px,2vw,23px);letter-spacing:-.02em;margin-top:5px;font-weight:600}
.oso-foot-news p{color:#8c8880;font-size:12.5px;margin-top:6px;max-width:340px;line-height:1.5}
.fn-form{display:flex;gap:9px;flex:none}
.fn-form input{background:rgba(255,255,255,.05);border:1px solid rgba(234,232,223,.18);border-radius:3px;padding:11px 18px;color:#eae8df;font-family:inherit;font-size:14px;width:230px;outline:none;transition:border-color .2s}
.fn-form input:focus{border-color:#eae8df}.fn-form input::placeholder{color:#726d63}
.fn-form button{background:#eae8df;color:#17150f;border:none;border-radius:3px;padding:0 24px;font-weight:800;font-family:inherit;font-size:14px;cursor:pointer;white-space:nowrap;transition:background .2s}
.fn-form button:hover{background:#fff}
.oso-foot-in{max-width:1120px;margin:6px auto 0;display:grid;grid-template-columns:1.4fr 2fr;gap:52px}
/* the real mark sets OSO tight, the old 6px tracking read as three loose letters */
.oso-foot-brand .lg{font-weight:700;letter-spacing:.5px;color:#eae8df;font-size:26px}
.oso-foot-brand .blurb{color:#8c8880;margin-top:14px;font-size:13.5px;line-height:1.65;max-width:290px}
.oso-foot-social{display:flex;gap:10px;margin-top:20px}
.oso-foot-social a{width:38px;height:38px;border-radius:50%;border:1px solid rgba(234,232,223,.16);display:flex;align-items:center;justify-content:center;color:#a8a49a;transition:.2s}
.oso-foot-social a:hover{color:#17150f;background:#eae8df;border-color:#eae8df;transform:translateY(-2px)}
.oso-foot-social svg{width:17px;height:17px;fill:currentColor}
.oso-foot-cols{display:grid;grid-template-columns:repeat(4,1fr);gap:24px}
.oso-foot-cols h5{color:#eae8df;font-size:11.5px;letter-spacing:1.6px;text-transform:uppercase;margin-bottom:15px;font-weight:700}
.oso-foot-cols a{display:block;color:#8c8880;text-decoration:none;font-size:13px;margin-bottom:11px;transition:color .2s,transform .2s}
.oso-foot-cols a:hover{color:#eae8df;transform:translateX(3px)}
.oso-foot-trust{max-width:1120px;margin:44px auto 0;display:grid;grid-template-columns:repeat(4,1fr);gap:18px;padding:24px 0;border-top:1px solid rgba(234,232,223,.1);border-bottom:1px solid rgba(234,232,223,.1)}
.oso-foot-trust .ti{display:flex;align-items:center;gap:12px}
.oso-foot-trust .ti svg{width:24px;height:24px;flex:none;stroke:#a8a49a;fill:none;stroke-width:1.6}
.oso-foot-trust .ti b{display:block;color:#eae8df;font-size:13px;font-weight:700}
.oso-foot-trust .ti span{color:#726d63;font-size:11.5px}
.oso-foot-bar{max-width:1120px;margin:24px auto 0;display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:10px;font-size:11.5px;color:#726d63}
.oso-foot-bar .pay{display:flex;gap:7px;align-items:center;color:#8c8880}
.oso-foot-bar .pay span{border:1px solid rgba(234,232,223,.14);border-radius:4px;padding:3px 7px;font-size:9.5px;font-weight:700;letter-spacing:.5px;color:#8c8880}
.oso-foot-bar .credit a{color:#a8a49a;text-decoration:none;font-weight:600;border-bottom:1px solid rgba(168,164,154,.4);transition:color .2s,border-color .2s}
.oso-foot-bar .credit a:hover{color:#eae8df;border-color:#eae8df}
@media(max-width:820px){.oso-foot-news{flex-direction:column;align-items:stretch;padding:22px 20px;gap:18px}
  /* the input would not shrink past its content, so the Join button was pushed
     out of the box — min-width:0 lets it give way */
  .fn-form{width:100%;flex:1 1 auto}
  .fn-form input{flex:1 1 auto;width:auto;min-width:0}
  .fn-form button{flex:0 0 auto;padding:0 18px}
  .oso-foot-news p{max-width:none}
  .oso-foot-in{grid-template-columns:1fr;gap:36px}.oso-foot-cols{grid-template-columns:1fr 1fr}
  .oso-foot-trust{grid-template-columns:1fr 1fr;gap:20px}.oso-foot-bar{justify-content:center;text-align:center}}`;
  osoAddStyle(Object.assign(document.createElement('style'),{textContent:css}));

  const heart='<svg viewBox="0 0 24 24"><path d="M12 20s-7-4.6-7-10a3.8 3.8 0 0 1 7-1.6A3.8 3.8 0 0 1 19 10c0 5.4-7 10-7 10Z"/></svg>';
  const bag='<svg viewBox="0 0 24 24"><path d="M6 8h12l-1 12H7L6 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';
  const user='<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4.5 20c0-4 3.4-7 7.5-7s7.5 3 7.5 7"/></svg>';

  /* ---- header ---- */
  const nav=document.createElement('nav'); nav.className='oso-nav';
  nav.innerHTML=
    `<a class="oso-nav-lg" href="${homeHref}" id="osoNavLg" aria-label="OSO home"></a>`+
    `<div class="oso-nav-links">`+
      `<a class="oso-nav-link${onHome?' active':''}" href="${homeHref}">Home</a>`+
      `<a class="oso-nav-link${onShop?' active':''}" href="/collections/all">Shop</a>`+
      `<a class="oso-nav-link${onAbout?' active':''}" href="${storyHref}">Our Story</a>`+
      `<a class="oso-nav-link${onContact?' active':''}" href="${contactHref}">Contact</a>`+
    `</div>`+
    `<div class="oso-icons">`+
      `<a class="oso-ic${onWish?' active':''}" href="/pages/wishlist" aria-label="Wishlist" title="Wishlist">${heart}<span class="oso-badge" id="osoWishBadge"></span></a>`+
      `<a class="oso-ic${onCart?' active':''}" href="/cart" aria-label="Bag" title="Bag">${bag}<span class="oso-badge" id="osoCartBadge"></span></a>`+
      `<a class="oso-ic${onAccount?' active':''}" href="/account" aria-label="Account" title="My account">${user}</a>`+
      `<button class="oso-burger" id="osoBurger" aria-label="Menu" aria-expanded="false"><span></span><span></span><span></span></button>`+
    `</div>`;
  document.body.prepend(nav);

  /* ---- phone menu: the links are hidden under 820px, so they get a panel ---- */
  {
    const panel=document.createElement('div');
    panel.className='oso-mnav'; panel.id='osoMnav'; panel.setAttribute('aria-hidden','true');
    panel.innerHTML=
      `<a class="oso-mlink${onHome?' active':''}" href="${homeHref}">Home</a>`+
      `<a class="oso-mlink${onShop?' active':''}" href="/collections/all">Shop</a>`+
      `<a class="oso-mlink${onAbout?' active':''}" href="${storyHref}">Our Story</a>`+
      `<a class="oso-mlink${onContact?' active':''}" href="${contactHref}">Contact</a>`+
      `<div class="oso-mfoot">`+
        `<a href="/pages/build">Build a set</a><a href="/pages/wishlist">Wishlist</a>`+
        `<a href="/cart">Your bag</a><a href="/account">My account</a>`+
      `</div>`;
    document.body.appendChild(panel);
    const burger=document.getElementById('osoBurger');
    const setOpen=o=>{
      document.body.classList.toggle('oso-mopen',o);
      panel.classList.toggle('on',o);
      burger.classList.toggle('on',o);
      burger.setAttribute('aria-expanded',String(o));
      panel.setAttribute('aria-hidden',String(!o));
    };
    burger.addEventListener('click',()=>setOpen(!panel.classList.contains('on')));
    panel.addEventListener('click',e=>{if(e.target.tagName==='A') setOpen(false);});
    addEventListener('keydown',e=>{if(e.key==='Escape') setOpen(false);});
    addEventListener('resize',()=>{if(innerWidth>820) setOpen(false);});
  }

  /* ---- transparent header at the top of every page, solid once you scroll ---- */
  {
    const hero=document.getElementById('hero');
    const syncNav=()=>{
      const past = hero ? (hero.getBoundingClientRect().bottom <= (nav.offsetHeight+8)) : (scrollY>40);
      nav.classList.toggle('tr', !past);
    };
    syncNav();
    addEventListener('scroll',syncNav,{passive:true});
    addEventListener('resize',syncNav);
  }

  /* ---- paper grain: inject once, site-wide ---- */
  if(!document.querySelector('.oso-grain')){
    const gr=document.createElement('div'); gr.className='oso-grain'; gr.setAttribute('aria-hidden','true');
    document.body.appendChild(gr);
  }
  /* the hero is a sticky stage, which traps its children in their own stacking
     context, so it gets its own grain layer, sitting under the product grid
     rather than over the photographs */
  const stage=document.querySelector('.hero .stage');
  if(stage && !stage.querySelector('.oso-grain-in')){
    const g2=document.createElement('div'); g2.className='oso-grain oso-grain-in'; g2.setAttribute('aria-hidden','true');
    stage.appendChild(g2);
  }

  /* ---- footer ---- */
  const ig='<svg viewBox="0 0 24 24"><path d="M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 1.8.3 2.2.4.6.2 1 .5 1.4.9.4.4.7.8.9 1.4.2.4.4 1 .4 2.2.1 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.3 1.8-.4 2.2-.2.6-.5 1-.9 1.4-.4.4-.8.7-1.4.9-.4.2-1 .4-2.2.4-1.3.1-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-1.8-.3-2.2-.4-.6-.2-1-.5-1.4-.9-.4-.4-.7-.8-.9-1.4-.2-.4-.4-1-.4-2.2C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.9c.1-1.2.3-1.8.4-2.2.2-.6.5-1 .9-1.4.4-.4.8-.7 1.4-.9.4-.2 1-.4 2.2-.4C8.4 2.2 8.8 2.2 12 2.2Zm0 3.2A6.6 6.6 0 1 0 18.6 12 6.6 6.6 0 0 0 12 5.4Zm0 10.9A4.3 4.3 0 1 1 16.3 12 4.3 4.3 0 0 1 12 16.3Zm6.8-11.2a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5Z"/></svg>';
  const pin='<svg viewBox="0 0 24 24"><path d="M12 2a10 10 0 0 0-3.6 19.3c-.1-.8-.1-2 0-2.9l1.2-5.1s-.3-.6-.3-1.5c0-1.4.8-2.5 1.9-2.5.9 0 1.3.7 1.3 1.5 0 .9-.6 2.2-.9 3.5-.2 1 .5 1.9 1.6 1.9 1.9 0 3.2-2.4 3.2-5.3 0-2.2-1.5-3.8-4.2-3.8a4.8 4.8 0 0 0-5 4.8c0 .9.3 1.6.7 2.1.2.2.2.3.1.5l-.2.9c-.1.3-.3.4-.6.2-1.2-.5-1.7-1.9-1.7-3.4C5.2 8 7.2 5 12.2 5c4 0 6.7 2.9 6.7 6 0 4.1-2.3 7.2-5.6 7.2-1.1 0-2.2-.6-2.5-1.3l-.7 2.7c-.2.9-.8 2-1.2 2.6A10 10 0 1 0 12 2Z"/></svg>';
  const tk='<svg viewBox="0 0 24 24"><path d="M16.5 5.3a5 5 0 0 0 3.3 1.4V9a7.4 7.4 0 0 1-3.9-1.1v6.5a5.4 5.4 0 1 1-5.4-5.4c.3 0 .6 0 .8.1v2.6a2.8 2.8 0 1 0 2 2.7V2h2.6a5 5 0 0 0 .6 3.3Z"/></svg>';

  /* Social handles live here, one place, site-wide. An entry with an empty URL is
     simply not rendered, so the footer never carries a dead icon. Add the handle
     and the icon appears everywhere. */
  const SOCIAL = [
    ['Instagram', 'https://instagram.com/oso.shop.in', ig],
    ['Pinterest', '',  pin],
    ['TikTok',    '',  tk],
  ];
  const socialHTML = SOCIAL.filter(s => s[1])
    .map(([name, url, icon]) => `<a href="${url}" target="_blank" rel="noopener" aria-label="${name}">${icon}</a>`)
    .join('');

  const foot=document.createElement('footer'); foot.className='oso-foot';
  foot.innerHTML=
    `<div class="oso-foot-mark" aria-hidden="true">OSO</div>`+
    `<div class="oso-foot-news">`+
      `<div class="fn-tx"><div class="fn-k">Life in the Slow Lane</div><h4>Get 10% off your first order.</h4>`+
        `<p>We will not bother you. You will only hear from us when there is a new drop.</p></div>`+
      `<form class="fn-form" id="osoFootNews"><input type="email" required placeholder="you@email.com" aria-label="Email"><button type="submit">Join &rarr;</button></form>`+
    `</div>`+
    `<div class="oso-foot-in">`+
      `<div class="oso-foot-brand"><div class="lg">OSO</div>`+
        `<p class="blurb">Premium Supima tees, made slow, for the dinner, the errand, the cab home.</p>`+
        `<div class="oso-foot-social">${socialHTML}</div></div>`+
      `<div class="oso-foot-cols">`+
        `<div><h5>Shop</h5><a href="/pages/product?id=bear-tee">Bear Tee</a><a href="/pages/product?id=signature-tee">Signature Tee</a><a href="/pages/product?id=vibe-tee">Vibe Tee</a><a href="/pages/build">Build a set</a></div>`+
        `<div><h5>Company</h5><a href="${storyHref}">Our Story</a><a href="${A('#material')}">The Material</a><a href="${A('#feature')}">The Fit</a><a href="${contactHref}">Contact</a></div>`+
        `<div><h5>Help</h5><a href="${contactHref}">Contact us</a><a href="/policies/shipping-policy">Shipping policy</a><a href="/policies/refund-policy">Returns &amp; refunds</a><a href="/policies/terms-of-service">Terms &amp; conditions</a><a href="/policies/privacy-policy">Privacy policy</a><a href="/cart">Your bag</a></div>`+
        `<div><h5>Account</h5><a href="/account">My account</a><a href="/pages/wishlist">Wishlist</a><a href="/account">Order history</a><a href="${A('#slowclub')}">Life in the Slow Lane</a></div>`+
      `</div>`+
    `</div>`+
    `<div class="oso-foot-trust">`+
      `<div class="ti"><svg viewBox="0 0 24 24"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg><div><b>Free shipping</b><span>on orders over ₹1,900</span></div></div>`+
      `<div class="ti"><svg viewBox="0 0 24 24"><path d="M4 12a8 8 0 0 1 13.6-5.7L20 8"/><path d="M20 4v4h-4"/><path d="M20 12a8 8 0 0 1-13.6 5.7L4 16"/><path d="M4 20v-4h4"/></svg><div><b>7-day returns</b><span>easy &amp; free</span></div></div>`+
      `<div class="ti"><svg viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg><div><b>Secure checkout</b><span>every order encrypted</span></div></div>`+
      `<div class="ti"><svg viewBox="0 0 24 24"><path d="M12 3s6 3 6 9-6 9-6 9-6-3-6-9 6-9 6-9Z"/><path d="M12 3v18"/></svg><div><b>Made slow</b><span>in India, for bear hugs</span></div></div>`+
    `</div>`+
    `<div class="oso-foot-bar"><span>© 2026 OSO Clothing · Made for bear hugs.</span>`+
      `<span class="pay"><span>VISA</span><span>UPI</span><span>MASTERCARD</span></span>`+
      `<span class="credit">Designed by <a href="https://mrinalmishra.dev" target="_blank" rel="noopener">Mrinal Mishra</a></span></div>`;
  document.body.appendChild(foot);

  /* ---- brand mark: the proper OSO lockup (bear above OSO), static, exact guideline proportions ---- */
  if(window.OSO_LOGO && window.buildOsoLogo){
    document.getElementById('osoNavLg').innerHTML=
      '<span class="lg-lockup">'+buildOsoLogo('lockup','#000000')+'</span>';
  }

  /* ---- cart + wishlist badges (live) ---- */
  function syncBadges(pop){
    if(!window.OSO_STORE) return;
    const cc=OSO_STORE.cartCount(), wc=OSO_STORE.wishlistCount();
    const cb=document.getElementById('osoCartBadge'), wb=document.getElementById('osoWishBadge');
    [[cb,cc],[wb,wc]].forEach(([el,n])=>{if(!el)return;el.textContent=n;el.style.display=n?'flex':'none';
      if(pop&&n&&window.gsap)gsap.fromTo(el,{scale:.2},{scale:1,duration:.4,ease:'back.out(3)'});});
  }
  syncBadges(false);
  window.addEventListener('oso:store',()=>syncBadges(true));


  /* ---- footer newsletter ----
     On the store, swap our cosmetic form for the real {% form 'customer' %} the
     theme renders (oso-newsletter.liquid) so the shopper types and clicks directly
     on Shopify's own form. That matters: Shopify loads reCAPTCHA lazily when a real
     customer form is focused, and only its markup can carry the CAPTCHA token. Any
     scripted hand-off skips the focus, the token is never minted, and the button
     silently does nothing — which is exactly what it did.

     Off the store there is no /contact endpoint, so our form stays and shows a toast. */
  const real=document.getElementById('osoNewsReal');
  const nf=document.getElementById('osoFootNews');
  if(real && nf && nf.parentNode){
    nf.parentNode.replaceChild(real, nf);   // same slot, same .fn-form styling
    const holder=document.getElementById('osoNewsHolder');
    if(holder) holder.remove();
    real.style.display='';
    /* Shopify posts to the form's own action, /contact — which 404s on this store,
       because the contact page lives at /pages/contact. Signing up therefore landed
       people on a Not Found page. return_to sends them back where they started.
       The Liquid carries this too; belt and braces, because compiled snippets can
       sit stale on Shopify's side for a while after a push. */
    /* Carry customer_posted in the return path. Shopify only appends it when it
       picks the destination itself — hand it a return_to and it redirects there
       verbatim, so without this the shopper lands back silently with no idea the
       signup worked. */
    let rt=real.querySelector('[name=return_to]');
    if(!rt){
      rt=document.createElement('input');
      rt.type='hidden'; rt.name='return_to';
      real.appendChild(rt);
    }
    rt.value=location.pathname+'?customer_posted=true';
  } else if(nf){
    nf.addEventListener('submit',e=>{
      e.preventDefault();
      const i=nf.querySelector('input');
      if(!(i.value||'').trim()) return;
      if(window.OSO_STORE)OSO_STORE.toast("You're in, life in the slow lane",'heart');
      i.value=''; i.blur();
    });
  }
  /* Shopify sends the visitor back with ?customer_posted=true once it has the address.
     Strip it straight afterwards: left in the URL it re-fires on every refresh, and on
     a page the shopper then bookmarks or shares it greets them forever. replaceState
     rewrites the address bar without another request or a history entry. */
  if(/[?&]customer_posted=true/.test(location.search)){
    if(window.OSO_STORE) OSO_STORE.toast("You're in, check your inbox for the welcome note",'heart');
    try{
      const u=new URL(location.href);
      u.searchParams.delete('customer_posted');
      history.replaceState(null,'',u.pathname+(u.search||'')+u.hash);
    }catch(e){/* older browsers simply keep the parameter */}
  }
})();

/* ================= Oso peeks out from behind a product grid ================= */
(function peekSetup(){
  osoAddStyle(Object.assign(document.createElement('style'),{textContent:`
.oso-peek{position:absolute;bottom:100%;pointer-events:none;overflow:hidden;z-index:2;line-height:0;visibility:hidden}
.oso-peek.ready{visibility:visible}
/* hidden behind the grid edge from the very first paint, stops him flashing in before the grid renders */
.oso-peek img{display:block;width:100%;height:auto;transform-origin:50% 100%;transform:translateY(104%)}
/* he peeks on phones too, just smaller — see the width scaling in osoPeek */
@media(prefers-reduced-motion:reduce){.oso-peek{display:none}}`}));

  window.osoPeek=function(sel,opts){
    opts=opts||{};
    const host=document.querySelector(sel); if(!host||!window.gsap) return;
    if(host.dataset.peek) return; host.dataset.peek='1';
    /* He must NOT be a child of the host. Both product grids centre a lone third
       card with .card:nth-child(3):last-child, and appending him made HIM the last
       child — the rule stopped matching and the third tee slid back into the left
       column. He lives in the host's parent now and is positioned over it, so no
       structural selector can ever see him. */
    const mount=host.parentElement||host;
    if(getComputedStyle(mount).position==='static') mount.style.position='relative';
    /* On a phone he was scaled to 60%, which meant a 30px sliver of his head
       cleared the frame — there, but not something you would ever notice.
       85% keeps him in proportion to the tiles and actually readable. */
    const small=innerWidth<=700;
    /* he reads better small: a large bear next to the tiles competes with the
       product, which is the thing meant to be looked at. */
    const w=Math.round((opts.width||124)*(small?0.66:0.78));
    const box=document.createElement('div');
    box.className='oso-peek';
    box.style.width=w+'px';
    box.style.height=Math.round(w*(small?0.95:0.78))+'px';
    box.innerHTML='<img src="'+(opts.src||((window.OSO_ASSET||'')+'media_oso-front.webp'))+'" alt="" aria-hidden="true">';
    mount.appendChild(box);
    const img=box.querySelector('img');
    gsap.set(img,{yPercent:104});
    const rr=(a,b)=>a+Math.random()*(b-a);
    const ri=n=>Math.floor(Math.random()*n);

    /* he never comes up in the same place twice, a fresh slot, facing and
       dwell time are drawn before every peek */
    const slots=opts.slots||[8,26,44,62,80];
    let last=-1;
    const reposition=()=>{
      let i=ri(slots.length); if(slots.length>1) while(i===last) i=ri(slots.length);
      last=i;
      const mr=mount.getBoundingClientRect(), hrx=host.getBoundingClientRect();
      const span=hrx.width-w;
      box.style.left=Math.round((hrx.left-mr.left)+Math.max(6,Math.min(span-6,span*slots[i]/100)))+'px';
      gsap.set(img,{scaleX:Math.random()<.5?-1:1});
      /* The box normally hangs off the top of the host. On a grid taller than the
         screen that lands off-view or under the header, so slide it down to a row
         that is actually on screen — he then comes up from behind the grid right
         where the shopper is looking, instead of somewhere they scrolled past. */
      const hr=hrx, bh=box.offsetHeight||Math.round(w*0.8);
      const HEAD=96;                       // announcement bar + fixed nav
      const lo=HEAD+12, hi=innerHeight-bh-12;
      let wantY=hr.top-bh;                 // his default spot: just above the host
      /* If that spot is under the header or off the screen — which it is for most of
         the time you spend looking at a grid — drop him to a row that is actually in
         front of the shopper, clamped to stay within the host. */
      if(wantY<lo||wantY>hi) wantY=Math.max(lo,Math.min(hi,innerHeight*0.55));
      const topWithin=Math.max(-bh,Math.min(hr.height-bh,wantY-hr.top));
      box.style.bottom='auto';
      box.style.top=Math.round((hr.top-mr.top)+topWithin)+'px';
    };

    /* His box hangs above the host (bottom:100%). On a tall grid that spot is
       either scrolled off the top or tucked under the fixed header, so he was
       peeking where nobody was looking — which is why he only ever showed up on
       the PDP, whose gallery is short. Skip a turn whenever the box is not in the
       clear, and try again shortly. */
    const HEADER=96;   // announcement bar + nav
    const onScreen=()=>{const r=box.getBoundingClientRect();
      return r.bottom>HEADER && r.top<innerHeight-8 && r.width>0;};
    const loop=()=>{
      if(!onScreen()){ gsap.delayedCall(0.6,loop); return; }
      reposition();
      const up=opts.peek||(small?8:14), tl=gsap.timeline({onComplete:()=>gsap.delayedCall(rr(1.6,3.6),loop)});
      tl.to(img,{yPercent:rr(up-4,up+7),duration:rr(.85,1.15),ease:'back.out(1.35)'})
        .to(img,{rotation:3.5,duration:.6,yoyo:true,repeat:1,ease:'sine.inOut'},'-=.25')
        .to(img,{rotation:-3,duration:.6,yoyo:true,repeat:1,ease:'sine.inOut'});
      if(Math.random()<.4) tl.to(img,{yPercent:'+=7',duration:.45,yoyo:true,repeat:1,ease:'sine.inOut'});
      tl.to(img,{yPercent:104,duration:.75,ease:'power2.in'},'+='+rr(.4,1.6).toFixed(2));
    };

    /* only once the grid is actually on screen AND has rendered its cards, 
       otherwise he pops up over an empty grid on slower/retina paints */
    const ready=()=>{
      const card=host.children[0];
      if(!card) return host.getBoundingClientRect().height>20;   /* hosts with no cards (PDP gallery) */
      return card.getBoundingClientRect().height>20;
    };
    let started=false;
    const start=()=>{ if(started||!ready()) return false;
      started=true; box.classList.add('ready'); gsap.delayedCall(rr(.8,1.8),loop); return true; };
    const io=new IntersectionObserver(es=>{
      if(es.some(e=>e.isIntersecting) && start()) io.disconnect();
    },{threshold:.25});
    io.observe(host);
    /* the observer only reports on threshold crossings, if the grid finished
       rendering after the first (empty) report, poll until it is worth peeking from */
    let tries=0;
    const poll=setInterval(()=>{
      const r=host.getBoundingClientRect();
      if(r.top<innerHeight && r.bottom>0 && start()){ io.disconnect(); clearInterval(poll); }
      else if(++tries>60) clearInterval(poll);
    },700);
  };
})();

/* ================= photo placeholders → the client's photography ================= */
window.OSO_LIFE=['life/couple','life/chest','life/flatlay2','life/supima-tag','life/sleeve','life/neck-label'];
(function fillPhotos(){
  osoAddStyle(Object.assign(document.createElement('style'),{textContent:`
.oso-ph-img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .7s cubic-bezier(.2,.7,.2,1)}
.life-cell:hover .oso-ph-img,.ab-ph:hover .oso-ph-img{transform:scale(1.05)}
.life-cell,.ab-ph,.ab-fitcard{overflow:hidden}
.ab-ph .ab-ph-in,.ab-fitcard .ab-ph-in{display:none}
.ab-ph{position:relative}
.ab-ph .ab-ph-tag{z-index:2;background:rgba(255,255,255,.92);color:#141310}`}));

  const put=(el,stem)=>{
    if(!stem||el.querySelector('.oso-ph-img')) return;
    const img=document.createElement('img');
    img.className='oso-ph-img'; img.loading='lazy'; img.decoding='async'; img.alt='';
    img.src=(window.OSO_ASSET||'')+'img_'+String(stem).replace('/','_')+'.webp';
    el.insertBefore(img,el.firstChild);
    /* the "lifestyle photo" placeholder is an absolutely-positioned overlay —
       once a real frame is in, it has to go or it covers the photograph */
    el.querySelectorAll('.life-ph,.ab-ph-in').forEach(p=>p.remove());
  };
  /* anything that names its own photograph */
  document.querySelectorAll('[data-img]').forEach(el=>put(el,el.dataset.img));
  /* lifestyle grids fall back to the house set */
  document.querySelectorAll('.life-grid').forEach(g=>{
    const use=(g.dataset.imgs||'').split(',').filter(Boolean);
    const list=use.length?use:window.OSO_LIFE;
    [...g.children].forEach((cell,i)=>put(cell,list[i%list.length]));
  });
})();

/* ================= announcement bar (with live launch countdown) ================= */
(function annc(){
  /* Deliberately NOT persisted: the offer is the first thing a returning visitor
     should see, so dismissing it lasts for this page view only. */
  osoAddStyle(Object.assign(document.createElement('style'),{textContent:`
/* One line, always. nowrap plus a clamped type size keeps the offer, the code and
   the link on a single row from 320px up, instead of wrapping into a two-line block
   that shoves the header down. */
.oso-annc{position:fixed;top:0;left:0;right:0;z-index:320;min-height:40px;display:flex;align-items:center;
  justify-content:center;gap:10px;flex-wrap:nowrap;white-space:nowrap;
  background:#000;color:#eae8df;font-size:clamp(10.5px,2.6vw,12.5px);font-weight:600;letter-spacing:.3px;
  padding:9px 40px;text-align:center;overflow:hidden}
.oso-annc .msg{overflow:hidden;text-overflow:ellipsis}
.oso-annc b{font-weight:800;color:#fff}
.oso-annc a{color:#eae8df;text-decoration:none;font-weight:800;border-bottom:1px solid rgba(234,232,223,.5);white-space:nowrap}
.oso-annc .cd{color:#eae8df;font-weight:800;font-variant-numeric:tabular-nums}
/* the discount code reads as something you can take, not just text */
.oso-annc .code{background:rgba(234,232,223,.14);border:1px dashed rgba(234,232,223,.5);color:#fff;
  font-family:inherit;font-size:inherit;font-weight:800;letter-spacing:1.3px;padding:3px 9px;border-radius:3px;
  cursor:pointer;transition:background .2s,border-color .2s;white-space:nowrap;flex:0 0 auto}
.oso-annc .code:hover{background:rgba(234,232,223,.26);border-color:#eae8df}
.oso-annc .x{position:absolute;right:14px;top:50%;transform:translateY(-50%);background:none;border:none;color:#8c8880;cursor:pointer;font-size:18px;line-height:1;padding:4px}
.oso-annc .x:hover{color:#fff}
body.has-annc .oso-nav{top:40px}
@media(max-width:640px){.oso-annc{gap:7px;padding:9px 34px}.oso-annc .hidesm{display:none}}
@media(max-width:380px){.oso-annc{gap:6px;padding:9px 30px;letter-spacing:0}}`}));
  const bar=document.createElement('div'); bar.className='oso-annc';
  /* The launch countdown this bar used to run is long past, so the standing offer
     lives here instead — one sticky strip rather than a second one competing with it.
     Tapping the code copies it, which saves retyping at checkout on a phone. */
  bar.innerHTML=
    `<span class="msg">Flat <b>10% off</b> your first order<span class="hidesm"> &middot; use code</span></span>`+
    `<button class="code" id="anncCode" title="Tap to copy">COZY10</button> `+
    `<a href="${/shop\.html$|\/collections\//.test(location.pathname)?'#shGrid':'/collections/all'}">Shop &rarr;</a>`+
    `<button class="x" id="anncX" aria-label="Dismiss">&times;</button>`;
  document.body.appendChild(bar); document.body.classList.add('has-annc');
  const codeBtn=document.getElementById('anncCode');
  codeBtn.addEventListener('click',()=>{
    const done=()=>{const t=codeBtn.textContent;codeBtn.textContent='Copied ✓';setTimeout(()=>codeBtn.textContent=t,1600);};
    if(navigator.clipboard&&navigator.clipboard.writeText) navigator.clipboard.writeText('COZY10').then(done,done);
    else done();
  });
  document.getElementById('anncX').addEventListener('click',()=>{bar.remove();document.body.classList.remove('has-annc');});
})();

/* ================= slide-in cart drawer + quick-view modal ================= */
(function ui(){
  if(!window.OSO_STORE) return;
  const S=OSO_STORE, rup=n=>'₹'+n.toLocaleString('en-IN');
  osoAddStyle(Object.assign(document.createElement('style'),{textContent:`
.oso-scrim{position:fixed;inset:0;background:rgba(20,16,36,.5);z-index:400;opacity:0;visibility:hidden;transition:opacity .3s,visibility .3s;-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px)}
.oso-scrim.on{opacity:1;visibility:visible}
.oso-drawer{position:fixed;top:0;right:0;bottom:0;width:min(420px,94vw);background:#eae8df;z-index:401;transform:translateX(100%);transition:transform .4s cubic-bezier(.2,.7,.2,1);display:flex;flex-direction:column;box-shadow:-24px 0 60px rgba(20,16,36,.3)}
.oso-drawer.on{transform:none}
.dr-head{display:flex;align-items:center;justify-content:space-between;padding:20px 22px;border-bottom:1px solid rgba(20,16,36,.1)}
.dr-head b{font-size:19px;letter-spacing:-.01em}
.dr-close,.qv-x{background:none;border:none;font-size:24px;line-height:1;color:#6a5c43;cursor:pointer;transition:transform .2s,color .2s}
.dr-close:hover,.qv-x:hover{color:#000;transform:rotate(90deg)}
.dr-prog{padding:13px 22px 4px}.dr-pl{font-size:12px;color:#6a5c43;margin-bottom:6px}.dr-pl b{color:#000}
.dr-bar{height:6px;border-radius:4px;background:#e6d9bb;overflow:hidden}.dr-bar span{display:block;height:100%;background:#000;border-radius:4px;transition:width .4s}
.dr-body{flex:1;overflow-y:auto;padding:6px 22px}
.dr-line{display:flex;gap:12px;padding:14px 0;border-bottom:1px solid rgba(20,16,36,.07)}
.dr-im{width:60px;height:60px;border-radius:11px;background:#e3e0d5;display:flex;align-items:center;justify-content:center;padding:8px;flex:none}
.dr-im{width:64px;height:80px;border-radius:2px;overflow:hidden;flex:0 0 auto}
.dr-mid{flex:1;min-width:0}.dr-nm{font-weight:700;font-size:14.5px}.dr-meta{color:#8a7a58;font-size:12px;margin:2px 0 8px}
.dr-qty{display:flex;align-items:center;gap:3px}
.dr-qty button{width:24px;height:24px;border:1px solid rgba(20,16,36,.15);background:#fff;border-radius:50%;cursor:pointer;font-size:14px;color:#000;display:flex;align-items:center;justify-content:center}
.dr-qty span{min-width:22px;text-align:center;font-weight:700;font-size:13px}
.dr-rm{border:none!important;background:none!important;width:auto!important;height:auto!important;margin-left:8px;color:#a08a5e;font-size:11.5px;cursor:pointer;font-family:inherit;border-radius:0!important}
.dr-rm:hover{color:#c0503f}
.dr-pr{font-weight:800;font-size:14px}
.dr-empty{text-align:center;padding:60px 20px;color:#6a5c43}.dr-empty .de-ic{font-size:42px}.dr-empty p{margin:12px 0 16px}.dr-empty a{color:#563e38;font-weight:800;text-decoration:none}
.dr-foot{padding:18px 22px;border-top:1px solid rgba(20,16,36,.1);background:#fff}
.dr-sub{display:flex;justify-content:space-between;align-items:center;margin-bottom:14px;font-size:14px;color:#4a4030}.dr-sub b{font-size:19px;color:#000}
.dr-checkout{display:block;text-align:center;background:#000;color:#fff;text-decoration:none;border-radius:13px;padding:14px;font-weight:800;transition:background .2s}
.dr-checkout:hover{background:#2a2a2a}
.dr-view{display:block;text-align:center;margin-top:10px;color:#6a5c43;font-size:13px;text-decoration:none}.dr-view:hover{color:#000}
.oso-qv{position:fixed;top:50%;left:50%;transform:translate(-50%,-46%) scale(.98);z-index:402;width:min(780px,94vw);max-height:90vh;overflow:auto;background:#eae8df;border-radius:24px;opacity:0;visibility:hidden;transition:opacity .3s,visibility .3s,transform .35s cubic-bezier(.2,.7,.2,1);display:grid;grid-template-columns:1fr 1fr;box-shadow:0 40px 90px rgba(20,16,36,.35)}
.oso-qv.on{opacity:1;visibility:visible;transform:translate(-50%,-50%) scale(1)}
.oso-qv .qv-x{position:absolute;top:12px;right:14px;z-index:3}
.qv-stage{background:#e3e0d5;display:flex;align-items:center;justify-content:center;padding:34px;border-radius:24px 0 0 24px}
.qv-tee{width:100%;height:100%}
.qv-info{padding:32px 30px 30px}
.qv-k{font-size:10.5px;letter-spacing:2.5px;text-transform:uppercase;color:#563e38;font-weight:800}
.qv-info h3{font-size:26px;letter-spacing:-.02em;margin-top:8px}
.qv-price{font-weight:800;font-size:20px;margin-top:6px}
.qv-info p{color:#5a4c33;font-size:13.5px;line-height:1.6;margin-top:12px}
.qv-lbl{font-size:12.5px;color:#6a5c43;margin-top:18px;font-weight:600}.qv-lbl b{color:#000}
.qv-sw{display:flex;gap:8px;margin-top:8px}
.qv-s{width:24px;height:24px;border-radius:50%;background:var(--c);border:2px solid #fff;box-shadow:0 0 0 1px rgba(20,16,36,.15);cursor:pointer;padding:0}
.qv-s.on{box-shadow:0 0 0 2px #000}
.qv-sz{display:flex;gap:8px;margin-top:8px}
.qv-z{min-width:40px;padding:9px 6px;border:1px solid rgba(20,16,36,.16);background:#fff;border-radius:10px;font-family:inherit;font-weight:700;font-size:13px;cursor:pointer}
.qv-z.on{background:#000;color:#fff;border-color:#000}.qv-z.soon{opacity:.4;cursor:not-allowed}
.qv-act{display:flex;gap:12px;align-items:center;margin-top:22px}
.qv-add{flex:1;background:#000;color:#fff;border:none;border-radius:13px;padding:14px;font-weight:800;font-family:inherit;font-size:14.5px;cursor:pointer;transition:background .2s}
.qv-add:hover{background:#2a2a2a}
.qv-full{color:#6a5c43;font-size:13px;text-decoration:none;white-space:nowrap}.qv-full:hover{color:#000}
@media(max-width:620px){.oso-qv{grid-template-columns:1fr;max-height:88vh}.qv-stage{border-radius:24px 24px 0 0;padding:0;min-height:280px}}`}));

  const scrim=document.createElement('div'); scrim.className='oso-scrim'; document.body.appendChild(scrim);
  const drawer=document.createElement('aside'); drawer.className='oso-drawer';
  drawer.innerHTML=`<div class="dr-head"><b>Your bag</b><button class="dr-close" aria-label="Close">&times;</button></div><div class="dr-prog"></div><div class="dr-body"></div><div class="dr-foot"></div>`;
  document.body.appendChild(drawer);
  const qv=document.createElement('div'); qv.className='oso-qv'; document.body.appendChild(qv);

  let open=null;
  const show=w=>{open=w;scrim.classList.add('on');(w==='drawer'?drawer:qv).classList.add('on');document.body.style.overflow='hidden';};
  const hide=()=>{scrim.classList.remove('on');drawer.classList.remove('on');qv.classList.remove('on');document.body.style.overflow='';open=null;};
  scrim.addEventListener('click',hide);
  document.addEventListener('keydown',e=>{if(e.key==='Escape')hide();});
  drawer.querySelector('.dr-close').addEventListener('click',hide);

  function renderDrawer(){
    const items=S.getCart(), body=drawer.querySelector('.dr-body'), foot=drawer.querySelector('.dr-foot'), prog=drawer.querySelector('.dr-prog');
    if(!items.length){body.innerHTML=`<div class="dr-empty"><div class="de-ic">🧸</div><p>Your bag is empty.</p><a href="/collections/all">Shop the drop &rarr;</a></div>`;prog.innerHTML='';foot.innerHTML='';return;}
    body.innerHTML=items.map(i=>{const p=OSO_findProduct(i.id);return `<div class="dr-line" data-key="${S.keyOf(i)}"><div class="dr-im">${shopTee(i.color,p.print)}</div><div class="dr-mid"><div class="dr-nm">${p.name}</div><div class="dr-meta">${i.cn} · ${i.size}</div><div class="dr-qty"><button data-d="-1">&minus;</button><span>${i.qty}</span><button data-d="1">+</button><button class="dr-rm" data-rm>Remove</button></div></div><div class="dr-pr">${rup(p.price*i.qty)}</div></div>`;}).join('');
    const sub=S.cartSubtotal(),disc=S.bundleDiscount(),net=sub-disc,left=Math.max(0,1900-net);
    prog.innerHTML=`<div class="dr-pl">${left>0?`Add <b>${rup(left)}</b> for free shipping`:'<b>Free shipping unlocked</b>'}</div><div class="dr-bar"><span style="width:${Math.min(100,net/1900*100)}%"></span></div>`;
    foot.innerHTML=`<div class="dr-sub"><span>Subtotal${disc?' · saved '+rup(disc):''}</span><b>${rup(S.cartTotal())}</b></div><a class="dr-checkout" href="/checkout">Checkout &rarr;</a><a class="dr-view" href="/cart">View full bag</a>`;
  }
  drawer.querySelector('.dr-body').addEventListener('click',e=>{
    const line=e.target.closest('.dr-line'); if(!line) return; const key=line.dataset.key;
    if(e.target.closest('[data-rm]')){S.removeFromCart(key);return;}
    const q=e.target.closest('[data-d]'); if(!q) return; const cur=S.getCart().find(i=>S.keyOf(i)===key); if(!cur) return;
    const nv=cur.qty+ +q.dataset.d; if(nv<1)S.removeFromCart(key); else S.setQty(key,nv);
  });

  const bagIc=document.querySelector('.oso-ic[href="/cart"]');
  if(bagIc && !/cart\.html$/.test(location.pathname)) bagIc.addEventListener('click',e=>{e.preventDefault();renderDrawer();show('drawer');});
  window.addEventListener('oso:added',()=>{renderDrawer();show('drawer');});
  window.addEventListener('oso:store',()=>{if(open==='drawer')renderDrawer();});

  window.osoQuickView=function(id,color){
    const p=OSO_findProduct(id);
    let cur=(color&&OSO_COLORS.some(c=>c[0]===color))?color:p.color, curCn=OSO_colorName(cur);
    let size=OSO_defaultSize(p.id,OSO_colorKey(cur));
    qv.innerHTML=`<button class="qv-x" aria-label="Close">&times;</button>
      <div class="qv-stage"><div class="qv-tee" id="qvTee">${shopTee(cur,p.print)}</div></div>
      <div class="qv-info"><div class="qv-k">${p.badge||'The Essential Tees'}</div><h3>${p.name}</h3><div class="qv-price">${rup(p.price)}</div><p>${p.desc}</p>
        <div class="qv-lbl">Colour · <b id="qvCn">${curCn}</b></div>
        <div class="qv-sw" id="qvSw">${OSO_productColors(p).map(c=>`<button class="qv-s${c[0]===cur?' on':''}" style="--c:${c[0]}" data-c="${c[0]}" data-n="${c[1]}" aria-label="${c[1]}"></button>`).join('')}</div>
        <div class="qv-lbl">Size</div>
        <div class="qv-sz" id="qvSz">${OSO_sizesFor(p.id,OSO_colorKey(cur)).map(([z,n])=>`<button class="qv-z${z===size&&n?' on':''}${n?'':' oos'}"${n?'':' disabled'}>${z}</button>`).join('')}</div>
        <div class="qv-act"><button class="qv-add" id="qvAdd">Add to bag</button><a class="qv-full" href="/pages/product?id=${id}&c=${cur.slice(1)}">Full details &rarr;</a></div></div>`;
    show('qv');
    qv.querySelector('.qv-x').addEventListener('click',hide);
    qv.querySelector('#qvSw').addEventListener('click',e=>{const s=e.target.closest('.qv-s'); if(!s) return; cur=s.dataset.c;curCn=s.dataset.n;
      qv.querySelectorAll('.qv-s').forEach(x=>x.classList.toggle('on',x===s)); qv.querySelector('#qvCn').textContent=curCn;
      qv.querySelector('#qvTee').innerHTML=shopTee(cur,p.print); if(window.gsap)gsap.fromTo('#qvTee .tee-img',{scale:1.06,autoAlpha:.3},{scale:1,autoAlpha:1,duration:.4});});
    qv.querySelector('#qvSz').addEventListener('click',e=>{const z=e.target.closest('.qv-z'); if(!z||z.classList.contains('soon')) return;
      qv.querySelectorAll('.qv-z').forEach(x=>x.classList.toggle('on',x===z)); size=z.textContent;});
    qv.querySelector('#qvAdd').addEventListener('click',()=>{qv.classList.remove('on'); S.addToCart(id,cur,curCn,size,1);});
  };
})();
